import { CardContainer, CardContent, CardTitle, CardPercentage, CardAbsoluteValue } from './CardElements'

type CardProps = {
  title: string;
  percentageValue: string;
  absoluteValue: string;
}

export default function Card(props: CardProps) {
  return (
    <CardContainer>
      <CardContent>
        <CardTitle>{props.title}</CardTitle>
        <CardPercentage>{props.percentageValue}</CardPercentage>
        <CardAbsoluteValue>{props.absoluteValue}</CardAbsoluteValue>
      </CardContent>
    </CardContainer>
  )
}